export function arrowButtonSlide() {
   const arrowButton = document.querySelector('.hero-scroll-button');
   const heroBanner = document.querySelector('.hero-banner');
   const bounding = heroBanner.getBoundingClientRect().height;

   arrowButton.addEventListener('click', (e) => {
      window.scrollTo({
         top: bounding,
         left: 0,
         behavior: 'smooth'
       });
   })
}